// extracted by mini-css-extract-plugin
export var box = "_3x-1";
export var checkboxRow = "_3x-8";
export var checked = "_3x-2";
export var descriptionSpacer = "_3x-a";
export var disabled = "_3x-3";
export var icon = "_3x-6";
export var input = "_3x-0";
export var labelSpacer = "_3x-9";
export var medium = "_3x-5";
export var small = "_3x-4";
export var text = "_3x-7";